// AboutUs.js
import React from "react";
import "./AboutUs.css";
import isoimg from "./workmates iso.jpg";

const AboutUs = () => {
  const turnoverData = [
    { year: "2021-22", amount: "4.41Cr" },
    { year: "2022-23", amount: "6.24Cr" },
    { year: "2023-24", amount: "12.26Cr" },
    { year: "2024-25", amount: "15.15Cr" },
  ];

  return (
    <div className="about-us-container">
      <header className="about-header">
        <h1>About WCPL Workmates Private Limited</h1>
      </header>

      <main className="about-content">
        <section className="company-intro">
          <div className="intro-text">
            <p>
              WCPL Workmates Private Limited is born from hard work and vast
              experience in construction and consulting works for the government
              sector. We are strongly committed to innovations, quality
              assurance, understanding project needs, delivering proper
              solutions, and time-bound completion of projects - all towards the
              entire satisfaction of customer needs.
            </p>
            <p>
              With complete response and taking overall responsibility, our
              specialization is in all types of Construction and Consultancy
              works. All our experience, expertise, and equipment of our team
              members enable us to continuously deliver excellent results and
              real-time solutions.
            </p>
            <p>
              WCPL Workmates (P) Ltd. provides integrated and customized
              services to clients for Irrigation and Infrastructure work.
            </p>
          </div>
          <div className="company-image">
            <img src={isoimg} alt="WCPL Workmates Office or Project" />
            {/* Replace with your actual image path */}
          </div>
        </section>

        <section className="empanelments">
          <h2>Our Empanelments</h2>
          <div className="empanelment-list">
            <ul>
              <li>Water Resources Department of Maharashtra state</li>
              <li>Water Conservation Department of Maharashtra State</li>
              <li>PWD, PMJSY, CMGSY</li>
              <li>Chhatrapati Sambhajinagar Municipal Corporation</li>
              <li>Gadhchiroli Municipal Corporation</li>
              <li>
                Bramhapuri, Ambarnath, Shegaon, Bodwad, Soygaon Municipal
                Council
              </li>
              <li>Jal Jivan Mishan Consultant</li>
              <li>NGO for WUA formation</li>
            </ul>
          </div>
        </section>

        <section className="achievements">
          <h2>Our Achievements</h2>
          <div className="achievement-list">
            <ul>
              <li>Award for awareness of water and WUA</li>
              <li>PMC for Real Estate Projects</li>
            </ul>
          </div>
        </section>

        <div className="turnover-container">
          <h2 className="turnover-title">COMPILED TURNOVER</h2>
          <div className="turnover-cards">
            {turnoverData.map((item, index) => (
              <div
                key={index}
                className="turnover-card"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="year">{item.year}</div>
                <div className="amount">{item.amount}</div>
                <div className="growth-indicator">
                  {index > -1 && <span className="growth-arrow">↑</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutUs;
